<template>
  <div class="d-container">
    <h-header title="无人机大赛"/> 
    <!-- Clients Section
    ==========================================-->
    <div id="tf-clients" class="text-center">
        <div class="overlay">
            <div class="container">
                <div class="section-title center">
                    <h2>软件下载，立即体验</h2>
                    <div class="line"> <hr></div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="col-md-4 " v-for="(item,index) in clientData" :key="'aa-' + index">
                        <div :class="`col-md-12 col-xs-6 client-item ${(item.active ? 'active' : '')} `"  @click="chooseSwiper(index)">
                            <div class="ii-box">
                              <img :src="item.paginationImage" :alt="item.title">
                              <div class="text" v-text="item.title">全球互联</div>
                            </div>
                        </div>
                    </div>
                    
                  </div>
                </div>
                <div class="row" style="margin-top:10px;">
                    <div class="col-md-12">
                      <div class="row max-inner">
                          <!-- start: blog item -->
                          <div class="columns col-md-3" v-for="(item, index) in chooseArray" :key="'bb-' + index">
                            <div class="grid-item">
                              <div class="grid-item-media"><a href="#"><img :src="item.imgHref"></a></div>
                              <div class="grid-item-desc">
                                  <h2>
                                  <a href="/">
                                      <span class="grid-item-meta" v-text="item.title"></span>
                                  </a>
                                  </h2>
                                  <a :href="item.download"><span class="grid-item-title">下载</span></a>
                              </div>
                            </div>
                          </div>
                          <!-- end: blog item -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <h-footer /> 
  </div>
</template>
<script>

import Header from '../../components/header/index.vue'
import Footer from '../../components/footer/index.vue'


export default {
  name: 'download',
  components: {
    'h-header': Header,
    'h-footer': Footer
  },
  data () {
    return {
      clientIndex: 1,
      clientData: [
        {
          paginationImage: '/work/static/img/download/desktop.png',
          title: '桌面设备'
        },
        {
          paginationImage: '/work/static/img/download/AR.png',
          title: 'AR设备'
        },
        {
          paginationImage: '/work/static/img/download/VR.png',
          title: 'VR设备'
        }
      ],
      clientArray: [
        [
          {
            imgHref: '/work/static/img/download/desktop.png',
            title: 'windows10',
            download: ''
          },
        ],
        [],
        []
        
      ],
      chooseArray: []
    }
  },
  created () {
    if (this.$route.query.type) { 
      this.type = this.$route.query.type 
    }
     this.chooseArray = this.clientArray[0]
  },
  mounted () {
  },
  methods: {
    chooseSwiper (index) {
      this.clientData = this.clientData.map((item) => {item.active = false; return item;})
      this.clientData[index].active = true
      this.clientIndex = index
      this.chooseArray = this.clientArray[index]
    }
  }
}
</script>
<style scoped lang="scss">
@import 'index';
</style>
